import { guessLocale, splitLocale, stripUniversalPrefix, translation, } from '@tymia/main-api';
import { assertDefined, } from '@tymia/shared';
import { last, omit, } from 'remeda';
import { api, } from '../../api/Api.js';
import { router, } from '../../router/router.js';
import { createOverridableChannelStore, } from '../../utils/OverridableChannelStore.js';
export const configStore = createOverridableChannelStore({
    name: 'config-store',
    initial: {
        state: 'uninitialized',
    },
});
let previousLocale;
async function handleStateChange(status, state) {
    if (status !== 'ready') {
        return;
    }
    if (state.state === 'error') {
        console.error('Error loading config', state.error);
        return;
    }
    const veryFirstCall = state.state === 'uninitialized';
    if (veryFirstCall) {
        try {
            const localeFromUrl = splitLocale(stripUniversalPrefix(new URL(window.location.href)).pathname).locale;
            const response = await api.common.config.request({
                urlLocale: localeFromUrl,
            });
            if (response.status !== 'ok') {
                throw new Error(`Error ${response.httpStatus}: ${response.message}`);
            }
            const locale = guessLocale(response.locale);
            const tRoot = translation(locale);
            const languagesTranslated = response.languagesTranslated
                .sort((a, b) => tRoot.collator.compare(a.display, b.display));
            previousLocale = locale;
            configStore.set({
                ...omit(response, ['status']),
                locale,
                state: 'initialized',
                languagesTranslated,
            });
        }
        catch (error) {
            configStore.setLocal({
                state: 'error',
                error: error instanceof Error ? error : new Error(String(error)),
            });
        }
        return;
    }
    if (previousLocale && previousLocale !== state.locale) {
        const routes = router().state.matches
            .filter(match => match.routeId !== '__root__');
        const route = last(routes);
        assertDefined(route);
        previousLocale = state.locale;
        return await router().navigate({
            to: route.routeId,
            params: route.params,
            search: route.search,
            resetScroll: false,
        });
    }
    if (previousLocale === undefined) {
        previousLocale = state.locale;
    }
}
configStore.subscribeStatus(async (status) => {
    await handleStateChange(status, configStore.get());
});
configStore.subscribe(async (state) => {
    await handleStateChange(configStore.status, state);
});
//# sourceMappingURL=ConfigStore.js.map